"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDestinationSuggestions = void 0;

var _lodash = require("lodash");

var _get = _interopRequireDefault(require("lodash/get"));

var constants = _interopRequireWildcard(require("../constants"));

var _urlLib = require("url-lib");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getFallbackSuggestions = function _getFallbackSuggestions() {
  return Promise.resolve(constants.FALLBACK_SUGGESTIONS);
};

var _parseDestinationSuggestions = function _parseDestinationSuggestions(response) {
  var suggestions = [];

  if (response.event && response.event.length > 0) {
    suggestions = response.event.map(function (_ref) {
      var url = _ref.url,
          name = _ref.name;
      return {
        value: url,
        content: name
      };
    });
  }

  return suggestions;
};

var _fetchDestinationSuggestions = function _fetchDestinationSuggestions(query, userLocation) {
  return fetch((0, _urlLib.formatUrl)(constants.DESTINATION_SUGGESTIONS_API_URL, {
    q: query,
    //eslint-disable-next-line
    completion_types: 'event',
    //eslint-disable-next-line
    place_id: (0, _get.default)(userLocation, ['placeId']),
    latitude: (0, _get.default)(userLocation, ['latitude']),
    longitude: (0, _get.default)(userLocation, ['longitude'])
  }), {
    method: 'GET'
  }).then(function (resp) {
    return resp.json();
  }).then(_parseDestinationSuggestions);
};
/**
 * @typedef SearchSuggestion
 * @property {string} value
 * @property {string} content
 */

/**
 * @typedef UserLocation
 * @property {string} placeId
 * @property {string} latitude
 * @property {string} longitude
 */

/**
 * Gets search suggestions based on specified query
 * @param {string} query Current search query
 * @param {object} UserLocation Place identifier for users current location
 * @returns Promise<SearchSuggestion[]>
 */


var getDestinationSuggestions = function getDestinationSuggestions(query, userLocation) {
  return (// less than 2 is because SOLR won't match on 1 letter
    !query || query.length < 2 ? _getFallbackSuggestions() : _fetchDestinationSuggestions(query, userLocation)
  );
};

exports.getDestinationSuggestions = getDestinationSuggestions;
//# sourceMappingURL=search.js.map